import React from "react";
import { useParams } from "react-router-dom";
import JobDetailPage from "./JobDetailPage";
import ExternalJobDetailPage from "./ExternalJobDetailPage";

/* Resuelve /jobs/:id entre el flujo propio (JobDetailPage, sin cambios) y el
   flujo de solo-lectura de empleos externos Adzuna, segun el prefijo del id. */
export default function JobDetailResolver() {
  const { id } = useParams();
  if (id && id.startsWith("adzuna:")) return <ExternalJobDetailPage />;
  return <JobDetailPage />;
}
